/* eslint-disable @typescript-eslint/no-use-before-define */
import { createAction } from '@reduxjs/toolkit'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import {
  getBestMatchStemPalette,
  getBestMatchStemPaletteByColor,
  getListStemPalettes,
  getStemPalette
} from 'src/api/stemPalette'
import { Pagination, PaginationParams, StemPalette } from 'src/common/common.interface'
import { stemPaletteAction } from './stemPalette.slice'
import { appAction } from '../app'

function* callGetStemPalettes({ payload }: ReturnType<typeof stemPaletteActionSaga.getStemPalettes>) {
  try {
    yield put(stemPaletteAction.setIsLoadingStemPalette(true))
    const response: Pagination<StemPalette[]> = yield call(getListStemPalettes, payload)
    yield put(stemPaletteAction.setPalettes(response.results))
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('error getListStemPalettes', error)
  } finally {
    yield put(stemPaletteAction.setIsLoadingStemPalette(false))
  }
}

function* getStemPalettesWithoutLoadingSaga({
  payload
}: ReturnType<typeof stemPaletteActionSaga.getStemPalettesWithoutLoading>) {
  try {
    const response: Pagination<StemPalette[]> = yield call(getListStemPalettes, payload)
    yield put(stemPaletteAction.setPalettes(response.results))
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('error callGetStemPalettesWithoutLoading', error)
  }
}

function* callGetStemPalette({ payload }: ReturnType<typeof stemPaletteActionSaga.getStemPalette>) {
  try {
    yield put(appAction.startLoading())
    const response: StemPalette = yield call(getStemPalette, payload)
    yield put(stemPaletteAction.setCurrentPalette(response))
    yield put(appAction.endLoading())
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('error getStemPalette', error)
  }
}

function* callGetBestMatchStemPalette({ payload }: ReturnType<typeof stemPaletteActionSaga.getBestMatchStemPalette>) {
  try {
    yield put(appAction.startLoading())
    const response: StemPalette = yield call(getBestMatchStemPalette, payload)
    yield put(stemPaletteAction.setBestMatchPalette(response))
    yield put(appAction.endLoading())
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('error getStemPalette', error)
  }
}

function* callGetBestMatchStemPaletteByColor({
  payload
}: ReturnType<typeof stemPaletteActionSaga.getBestMatchStemPaletteByColor>) {
  try {
    yield put(appAction.startLoading())
    const response: StemPalette = yield call(getBestMatchStemPaletteByColor, payload)
    yield put(stemPaletteAction.setBestMatchPalette(response))
    yield put(appAction.endLoading())
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('error getStemPalette', error)
  }
}

export const stemPaletteActionSaga = {
  getStemPalettes: createAction<PaginationParams>('stemPaletteActionSaga/getStemPalettes'),
  getStemPalettesWithoutLoading: createAction<PaginationParams>('stemPaletteActionSaga/getStemPalettesWithoutLoading'),
  getStemPalette: createAction<number>('stemPaletteActionSaga/getStemPalette'),
  getBestMatchStemPalette: createAction<number>('stemPaletteActionSaga/getBestMatchStemPalette'),
  getBestMatchStemPaletteByColor: createAction<string>('stemPaletteActionSaga/getBestMatchStemPaletteByColor')
}

export default [
  function* fetchWatcher() {
    yield all([
      takeLatest(stemPaletteActionSaga.getStemPalettes, callGetStemPalettes),
      takeLatest(stemPaletteActionSaga.getStemPalettesWithoutLoading, getStemPalettesWithoutLoadingSaga),
      takeLatest(stemPaletteActionSaga.getStemPalette, callGetStemPalette),
      takeLatest(stemPaletteActionSaga.getBestMatchStemPalette, callGetBestMatchStemPalette),
      takeLatest(stemPaletteActionSaga.getBestMatchStemPaletteByColor, callGetBestMatchStemPaletteByColor)
    ])
  }
]
